// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import MuiGrid from '@material-ui/core/Grid';
import createMuiSpacingRules from '../../birch/layouts/mui_spacing';

// A simple wrapper of the Material UI Grid Component
// References:
// https://material-ui.com/components/grid/
// https://material-ui.com/api/grid/
// https://www.dmcinfo.com/latest-thinking/blog/id/10114/a-simple-guide-to-material-ui-grids

type Width =
  | false
  | 'auto'
  | true
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12;

type Props = {
  container?: boolean,
  item?: boolean,
  xs?: Width,
  sm?: Width,
  md?: Width,
  lg?: Width,
  xl?: Width,
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10,
  alignContent?:
    | 'stretch'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around',
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline',
  children?: Node,
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse',
  justify?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly',
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly',
  /**
   * Custom style object (padding/margin styles only)
   */
  sx?: any,
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse',
  zeroMinWidth?: boolean,
};

// This value is multiplied by 8px and results in a 24px gutter between elements
// The 'spacing' value should only be passed to container elements
const DEFAULT_SPACING = 3;

// Dump the parsed rules into the styled component
/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const StyledMuiGrid = styled(MuiGrid)`
  ${({ sx }) => sx}
`;

function Grid({ container, sx, justifyContent, justify, ...rest }: Props) {
  const spacingSx = createMuiSpacingRules(sx);
  return container ? (
    <StyledMuiGrid
      spacing={DEFAULT_SPACING}
      container={container}
      justifyContent={justifyContent || justify}
      {...rest}
      sx={spacingSx}
    />
  ) : (
    <StyledMuiGrid
      container={container}
      justifyContent={justifyContent || justify}
      {...rest}
      sx={spacingSx}
    />
  );
}

export { Grid };
